import React, { memo } from 'react';
import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';

import { Action } from 'state';
import Section from 'types/Section';
import SectionHeader from './SectionHeader';
import SectionFields from './SectionFields';
import TemplateType from 'types/TemplateType';
interface SectionFormProps {
  section: Section;
  collapsed: boolean;
  dragHandleProps?: DraggableProvidedDragHandleProps|null;
  templateType: TemplateType;
  dispatch: (action: Action) => void;
}

const SectionForm: React.FC<SectionFormProps> = ({ section, collapsed, dragHandleProps, templateType, dispatch }) => {
  return (
    <>
      {!section.credits && (
        <SectionHeader
          section={section}
          dragHandleProps={dragHandleProps}
          dispatch={dispatch}
          templateType={templateType}
        />
      )}
      {collapsed ? null : <SectionFields section={section} dispatch={dispatch} />}
    </>
  );
};

export default memo(SectionForm);
